import { XClose } from '@timelyapp/icons/solid-icons';
import { Box, Button, Tooltip } from '@timelyapp/react';
import classNames from 'classnames';
import HourStateLabel from 'components/HourStateLabel';
import React from 'react';
import type { HourState } from 'redux/modules/hourStates.schema';
import HourStateDropdown from '../HourStateDropdown';
import { Section } from './Section';
import styles from './SelectedHourStateSection.module.scss';

interface SelectedHourStateSectionProps {
  selectedStateId: number;
  states: Record<number, HourState>;
  onChangeState: (selectedIds: Array<number> | null) => void;
  disableBillable?: boolean;
  disabled?: boolean;
}

const SelectedHourStateSection: React.FC<SelectedHourStateSectionProps> = ({
  selectedStateId,
  states,
  onChangeState,
  disableBillable = false,
  disabled = false,
}) => {
  const selectedState = states[selectedStateId];

  return (
    <Section className={classNames(styles.section, { [styles.disabled]: disabled })}>
      <Box.Row alignItems="center" justifyContent="space-between">
        <Tooltip tooltip="Change time entry state">
          <HourStateDropdown
            onChange={onChangeState}
            disableBillable={disableBillable}
            align="start"
            disabled={disabled}
            filterMode={false}
            showNoState
          >
            <HourStateLabel
              className={classNames(styles.hourStateLabel, { [styles.disabled]: disabled })}
              state={selectedState}
              size="small"
              inline
              style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
            />
          </HourStateDropdown>
        </Tooltip>
        <Tooltip tooltip={disabled ? 'This time entry is locked' : 'Remove time entry state'}>
          <Button
            size="xsmall"
            priority="xlow"
            onClick={() => onChangeState(null)}
            disabled={disabled}
          >
            <XClose />
          </Button>
        </Tooltip>
      </Box.Row>
    </Section>
  );
};

export default React.memo(SelectedHourStateSection);
